<template>
    <div>
        <div class="container mx-auto text-center max-w-lg">
            <div class="px-3 py-2">
                <h2 v-text="$t('DELIVERY_ADDRESS_WHO_ARE')"></h2>
            </div>
        </div>

        <gifting-addresses-table/>
    </div>
</template>

<script>
import GiftingAddressesTable from '@/components/partials/account/gifting/deliveryAddress/GiftingAddressesTable';

export default {
    name: 'DeliveryAddress',
    components: {
        GiftingAddressesTable,
    },
};
</script>
